<template>
  <div class="inputBox">
    <div style="
        text-align: left;
        justify-content: flex-start;
        align-items: center;
      " class="flexBox">
      <el-upload action=" " :before-upload="sendImg" multiple :limit="1" :disabled="!stateFlag">
        <i class="el-icon-picture-outline iconButton" title="发送图片"></i>
      </el-upload>
      <Camera :type="1" />
      <div>
        <i class="el-icon-tickets hoverIcon iconButton" title="开处方" @click="sendFlag"></i>
      </div>

      <!-- 快捷语输入建议 - 移动到右侧位置 -->
      <div class="quick-reply-container">
        <el-autocomplete v-model="quickReplyInput" :fetch-suggestions="queryQuickReplies" placeholder="常用快捷语及问答"
          @select="handleQuickReplySelect" @focus="onQuickReplyFocus" style="width: 420px;" ref="quickReplyAutocomplete"
          popper-class="quick-reply-dropdown">
          <template slot-scope="{ item }">
            <div class="suggestion-item">
              <span class="quick-reply-tag" :class="item.type === 2 ? 'qa-tag' : 'quick-tag'">
                <i :class="item.type === 2 ? 'el-icon-question' : 'el-icon-chat-dot-round'"></i>
                {{ item.type === 2 ? '问答' : '快捷语' }}
              </span>
              <span class="suggestion-title" :title="item.title">
                {{ item.title }}
              </span>
            </div>
          </template>
        </el-autocomplete>
      </div>
    </div>



    <!-- 主输入框和发送按钮 -->
    <div class="input-row" style="position: relative;">
      <el-input type="textarea" resize='none' v-model="input" @keyup.enter.native="handleEnterKey"
        @input="onMainInputChange" placeholder="请输入需要发送的信息！" ref="mainTextarea"
        :autosize="{ minRows: 8, maxRows: 12 }"></el-input>

      <div class="right-controls">
        <el-button 
          v-if="!hasDialogVisible" 
          @click="send()" 
          class="sendButton" 
          size="large" 
          type="success"
        >
          发送
        </el-button>
      </div>
    </div>

    <!-- 快捷语匹配popover -->
    <el-popover 
      placement="bottom-start" 
      width="400" 
      trigger="manual" 
      :append-to-body="false" 
      :popper-options="{
        boundariesElement: 'body',
        gpuAcceleration: true,
        positionFixed: true,
        preventOverflow: true
      }" 
      v-model="showQuickReplyPopover" 
      popper-class="main-input-popover" 
      ref="quickReplyPopover"
    >
      <div class="quick-reply-list" ref="quickReplyListRef">
        <div v-for="(item, index) in matchedQuickReplies" :key="item.id" class="quick-reply-item"
          :class="{ 'selected': selectedQuickReplyIndex === index }" @click="handleQuickReplyClick(item, index)"
          @dblclick="handleQuickReplyDoubleClick(item)" @mouseleave="clearSelection">
          <!-- 快捷语标识标签 -->
          <span class="quick-reply-tag" :class="item.type === 2 ? 'qa-tag' : 'quick-tag'">
            <i :class="item.type === 2 ? 'el-icon-question' : 'el-icon-chat-dot-round'"></i>
            {{ item.type === 2 ? '问答' : '快捷语' }}
          </span>
          <span class="item-text" :title="item.title">
            {{ item.title }}
          </span>
        </div>
      </div>
    </el-popover>

    <el-dialog :visible.sync="tipsFlag" width="30%" :show-close="false" :close-on-click-modal="false" :modal="false"
      class="tipsMsgBox">
      <span style="font-size: 20px; font-weight: 800">{{ tipsMsg }}</span>
    </el-dialog>
  </div>
</template>
<script>
import store from "../../../../store/store";
import { msgUp, imgUpload, imgDownLoad, getQuickReplyTemplates } from "@/api/index";
import Camera from "@/components/tool/Camera.vue";
export default {
  components: {
    Camera,
  },
  props: {
    hasDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      input: "",
      CF_Flag: false,
      tipsFlag: false,
      tipsMsg: "",
      storeImgData: {},
      // 快捷语相关数据
      quickReplyInput: "",
      quickReplyOptions: [],
      quickReplyLoading: false,
      quickReplySearchKeyword: "",
      showQuickReplyPopover: false,
      matchedQuickReplies: [],
      searchTimer: null, // 防抖定时器
      selectedQuickReplyId: null, // 当前选中的快捷语ID
      selectedQuickReplyIndex: -1, // 当前选中的快捷语索引
      // 分页滚动配置
      quickReplyPage: 1,
      quickReplyPageSize: 10,
      quickReplyPagesPerLoad: 1, // 每次加载1页（每页10条）
      quickReplyHasMore: true,
      quickReplyLoadingMore: false,
      quickReplyLastKeyword: "",

      // 右侧建议下拉的分页滚动配置
      suggestPage: 1,
      suggestPageSize: 10,
      suggestHasMore: true,
      suggestLoadingMore: false,
      suggestKeyword: "",
      suggestResults: [],
      suggestCb: null,
      suggestScrollBound: false,
    };
  },
  methods: {


    // 查询快捷语建议（右侧输入框，下拉可滚动分页）
    queryQuickReplies(queryString, cb) {
      this.quickReplyLoading = true;
      this.quickReplySearchKeyword = queryString || "";
      // 初始化建议列表分页状态
      this.suggestKeyword = this.quickReplySearchKeyword;
      this.suggestPage = 1;
      this.suggestHasMore = true;
      this.suggestResults = [];
      this.suggestCb = cb;
      this.suggestScrollBound = false;
      // 首次加载第一页
      this.fetchSuggestNextPage();
    },

    async fetchSuggestNextPage() {
      if (!this.suggestHasMore || this.suggestLoadingMore) return;
      this.suggestLoadingMore = true;
      const params = {
        cp: this.suggestPage,
        lz: this.suggestPageSize,
        pharmacyId: "",
        status: "",
        type: "",
        answerType: "",
        hospitalCode: "",
        doctorId: "",
        keyWords: this.suggestKeyword
      };
      try {
        const response = await getQuickReplyTemplates(params);
        if (response.code === 0 && response.data && Array.isArray(response.data.data)) {
          const batch = response.data.data.map(item => ({
            value: item.type === 2 ? item.answer : item.title,
            title: item.title,
            answer: item.answer,
            type: item.type,
            id: item.id
          }));
          this.suggestResults = this.suggestResults.concat(batch);
          if (this.suggestCb) this.suggestCb(this.suggestResults);
          // cp 自增
          this.suggestPage += 1;
          if (batch.length < this.suggestPageSize) this.suggestHasMore = false;
          this.$nextTick(() => {
            // 绑定下拉面板滚动事件（只绑定一次）
            const pop = document.querySelector('.el-autocomplete-suggestion__wrap');
            if (pop && !this.suggestScrollBound) {
              pop.addEventListener('scroll', this.onSuggestScroll, { passive: true });
              this.suggestScrollBound = true;
            }
          });
        } else {
          this.suggestHasMore = false;
          if (this.suggestCb) this.suggestCb(this.suggestResults);
        }
      } catch (e) {
        this.suggestHasMore = false;
        if (this.suggestCb) this.suggestCb(this.suggestResults);
      } finally {
        this.quickReplyLoading = false;
        this.suggestLoadingMore = false;
      }
    },

    // 右侧建议面板滚动分页
    onSuggestScroll(e) {
      const el = e.target;
      if (!el) return;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
      if (nearBottom && this.suggestHasMore && !this.suggestLoadingMore) {
        this.fetchSuggestNextPage();
      }
    },

    // 主输入框监听
    onMainInputChange(event) {
      // 从事件对象中获取输入值，兼容el-input组件
      const inputValue = event.target ? event.target.value : this.input;
      console.log('主输入框监听触发，输入值:', inputValue);

      // 自动调整textarea高度
      this.autoResize();



      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      // 确保value是字符串类型
      const searchValue = String(inputValue || '');

              if (!searchValue || searchValue.trim() === '') {
        this.hideQuickReplyPopover();
        console.log('输入为空，隐藏popover');
        return;
      }

      // 防抖：延迟300ms后调用接口
      this.searchTimer = setTimeout(() => {
        console.log('防抖后调用后端接口进行模糊匹配，输入值:', searchValue);
        this.searchQuickRepliesFromAPI(searchValue);
      }, 300);
    },

    // 自动调整textarea高度（保持兼容）
    autoResize() {
      // 由 el-input 的 autosize 负责高度，这里保留兼容不做实际操作
      // 但保留 nextTick 以避免调用处的依赖
      this.$nextTick(() => {});
    },

    // 重置分页并首次加载（按关键字搜索）
    resetQuickReplyPagination(keyword) {
      this.quickReplyLastKeyword = keyword;
      this.quickReplyPage = 1;
      this.quickReplyHasMore = true;
      this.matchedQuickReplies = [];
      this.selectedQuickReplyIndex = -1;
      this.selectedQuickReplyId = null;
    },

    // 拉取单页数据
    async fetchQuickRepliesPage(page, keyword) {
      const params = {
        cp: page,
        lz: this.quickReplyPageSize,
        pharmacyId: "",
        status: "",
        type: "",
        answerType: "",
        hospitalCode: "",
        doctorId: "",
        keyWords: keyword
      };
      const res = await getQuickReplyTemplates(params);
      if (res.code === 0 && res.data && Array.isArray(res.data.data)) {
        return res.data.data;
      }
      return [];
    },

    // 一次加载多个分页（默认5页）
    async loadQuickRepliesPages(pages = this.quickReplyPagesPerLoad) {
      if (!this.quickReplyHasMore || this.quickReplyLoadingMore) return;
      this.quickReplyLoadingMore = true;
      const keyword = this.quickReplyLastKeyword;
      const tasks = [];
      for (let i = 0; i < pages; i++) {
        tasks.push(this.fetchQuickRepliesPage(this.quickReplyPage + i, keyword));
      }
      try {
        const pagesResult = await Promise.all(tasks);
        const flat = pagesResult.flat();
        if (flat.length > 0) {
          this.matchedQuickReplies = this.matchedQuickReplies.concat(flat);
          this.quickReplyPage += pages; // 下一次从后续页继续
          // 如果返回少于请求的总期望数量，认为可能没有更多
          if (flat.length < pages * this.quickReplyPageSize) {
            this.quickReplyHasMore = false;
          }
          // 打开popover
          this.showQuickReplyPopover = true;
          // 默认选中第一个（如无选中）
          if (this.selectedQuickReplyIndex < 0 && this.matchedQuickReplies.length > 0) {
            this.selectedQuickReplyIndex = 0;
            this.selectedQuickReplyId = this.matchedQuickReplies[0].id;
          }
        } else {
          this.quickReplyHasMore = false;
        }
      } catch (e) {
        console.error('批量加载快捷语失败:', e);
      } finally {
        this.quickReplyLoadingMore = false;
        this.$nextTick(() => {
          // 绑定滚动事件
          const list = this.$refs.quickReplyListRef;
          if (list && list.addEventListener && !list._scrollBinded) {
            list.addEventListener('scroll', this.onQuickReplyListScroll, { passive: true });
            list._scrollBinded = true;
          }
        });
      }
    },

    // 列表滚动触底加载
    onQuickReplyListScroll(e) {
      const el = e.target;
      if (!el) return;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
      if (nearBottom && !this.quickReplyLoadingMore && this.quickReplyHasMore) {
        this.loadQuickRepliesPages();
      }
    },

    // 调用后端接口进行模糊匹配（带分页、滚动加载）
    async searchQuickRepliesFromAPI(inputValue) {
      console.log('调用后端接口进行模糊匹配，输入值:', inputValue);

      // 确保inputValue是字符串类型
      const searchValue = String(inputValue || '');

      // 设置popover的参考元素
      this.$nextTick(() => {
        if (this.$refs.quickReplyPopover && this.$refs.mainTextarea) {
          this.$refs.quickReplyPopover.referenceElm = this.$refs.mainTextarea.$el;
        }
      });

      // 如果上一次选择刚关闭弹层，且输入值与刚插入内容一致，直接返回避免误触发
      if (!this.showQuickReplyPopover && this.selectedQuickReplyIndex === -1 && this.matchedQuickReplies.length === 0 && this.quickReplyLastKeyword === searchValue) {
        return;
      }

      // 重置分页，并加载首批
      this.resetQuickReplyPagination(searchValue);
      await this.loadQuickRepliesPages();
    },

    // 搜索匹配的快捷语（本地匹配，保留备用）
    searchMatchedQuickReplies(inputValue) {
      console.log('开始搜索匹配项，输入值:', inputValue);
      console.log('快捷语数据总数:', this.quickReplyOptions.length);

      // 确保inputValue是字符串类型
      const searchValue = String(inputValue || '');
      const lowerInput = searchValue.toLowerCase();

      // 查找匹配的快捷语
      const matched = this.quickReplyOptions.filter(item => {
        const titleMatch = String(item.title || '').toLowerCase().includes(lowerInput);
        const answerMatch = item.type === 2 && String(item.answer || '').toLowerCase().includes(lowerInput);
        return titleMatch || answerMatch;
      });
      if (matched.length > 0) {
        this.matchedQuickReplies = matched.slice(0, 20); // 显示更多项目以触发滚动
        this.showQuickReplyPopover = true;
        console.log('显示popover，匹配项:', this.matchedQuickReplies);
      } else {
        this.matchedQuickReplies = [];
        this.showQuickReplyPopover = false;
      }
    },
    // 选择快捷语（仅回填到主输入框，不自动发送）
    handleQuickReplySelect(item) {
      if (item) {
        const displayText = item.type === 2 ? item.answer : item.title;
        this.input = displayText;
        this.quickReplyInput = "";
        // 回填后聚焦到主输入框，方便继续编辑或手动发送
        this.$nextTick(() => {
          const textarea = this.$refs.mainTextarea;
          if (textarea && textarea.focus) {
            textarea.focus();
          }
        });
      }
    },

    // 处理快捷语单击（直接回填到文本域，不发送）
    handleQuickReplyClick(item, index) {
      this.selectedQuickReplyIndex = index;
      this.selectedQuickReplyId = item.id;
      // 问答(type===2)回显答案，其它回显标题
      const displayText = item.type === 2 ? item.answer : item.title;
      this.input = displayText;
      // 彻底关闭弹层与计时器，避免延迟搜索再次打开
      this.hideQuickReplyPopover();
      this.$nextTick(() => {
        const textarea = this.$refs.mainTextarea;
        if (textarea && textarea.focus) {
          textarea.focus();
        }
      });
      console.log('单击快捷语，已回填到输入框:', displayText);
    },

    // 清除选中状态
    clearSelection() {
      this.selectedQuickReplyIndex = -1;
      this.selectedQuickReplyId = null;
    },

    // 处理快捷语双击（回填到输入框）
    handleQuickReplyDoubleClick(item) {
      const displayText = item.type === 2 ? item.answer : item.title;
      this.input = displayText;
      this.showQuickReplyPopover = false;
      this.matchedQuickReplies = [];
      this.selectedQuickReplyId = null; // 清除选中状态
      this.selectedQuickReplyIndex = -1; // 清除索引状态

      // 获取回填数据的信息
      const lineCount = displayText.split('\n').length;
      const charCount = displayText.length;
      console.log('回填数据信息:', {
        text: displayText.substring(0, 100) + (displayText.length > 100 ? '...' : ''),
        lineCount: lineCount,
        charCount: charCount
      });

      console.log('双击快捷语已回填到输入框:', displayText);
    },

    // 选择主输入框匹配的快捷语（仅回填，不发送）
    selectQuickReply(item) {
      if (item) {
        // 问答(type===2)回显答案，其它回显标题
        const displayText = item.type === 2 ? item.answer : item.title;
        this.input = displayText;
        this.hideQuickReplyPopover();
        this.$nextTick(() => {
          const textarea = this.$refs.mainTextarea;
          if (textarea && textarea.focus) {
            textarea.focus();
          }
        });
        console.log('快捷语已回填到输入框:', displayText);
      }
    },



    // 快捷语输入框获得焦点
    onQuickReplyFocus() {
      // 触发建议查询，加载默认数据
      this.queryQuickReplies("", (results) => {
        // 这里可以处理默认数据加载
      });
    },

    // 处理输入框回车键
    handleEnterKey(event) {
      console.log('handleEnterKey被调用', {
        showQuickReplyPopover: this.showQuickReplyPopover,
        matchedQuickRepliesLength: this.matchedQuickReplies.length,
        eventType: event.type,
        target: event.target
      });

      // 如果popover打开，不发送消息
      if (this.showQuickReplyPopover && this.matchedQuickReplies.length > 0) {
        console.log('popover打开，阻止发送消息');
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      // 否则正常发送
      console.log('popover关闭，正常发送消息');
      this.send();
    },

    // 处理键盘快捷键
    handleKeydown(event) {
      if (event.key === 'q' && event.ctrlKey) {
        event.preventDefault(); // 阻止默认行为
        const autocompleteElement = this.$el.querySelector('.quick-reply-container .el-autocomplete');
        if (autocompleteElement) {
          autocompleteElement.focus();
        }
      }

      // 处理快捷语popover的键盘导航
      if (this.showQuickReplyPopover && this.matchedQuickReplies.length > 0) {
        console.log('全局键盘事件处理popover', {
          key: event.key,
          showQuickReplyPopover: this.showQuickReplyPopover,
          matchedQuickRepliesLength: this.matchedQuickReplies.length
        });

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          event.stopPropagation();
          this.selectedQuickReplyIndex = Math.min(this.selectedQuickReplyIndex + 1, this.matchedQuickReplies.length - 1);
          this.selectedQuickReplyId = this.matchedQuickReplies[this.selectedQuickReplyIndex].id;
          console.log('向下选择，当前索引:', this.selectedQuickReplyIndex);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          event.stopPropagation();
          this.selectedQuickReplyIndex = Math.max(this.selectedQuickReplyIndex - 1, 0);
          this.selectedQuickReplyId = this.matchedQuickReplies[this.selectedQuickReplyIndex].id;
          console.log('向上选择，当前索引:', this.selectedQuickReplyIndex);
        } else if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          if (this.selectedQuickReplyIndex >= 0 && this.selectedQuickReplyIndex < this.matchedQuickReplies.length) {
            const selectedItem = this.matchedQuickReplies[this.selectedQuickReplyIndex];
            // 回填选中的快捷语到输入框（不自动发送）
            const displayText = selectedItem.type === 2 ? selectedItem.answer : selectedItem.title;
            this.input = displayText;
            this.showQuickReplyPopover = false;
            this.matchedQuickReplies = [];
            this.selectedQuickReplyId = null;
            this.selectedQuickReplyIndex = -1;
            // 聚焦回主输入框
            this.$nextTick(() => {
              const textarea = this.$refs.mainTextarea;
              if (textarea && textarea.focus) {
                textarea.focus();
              }
            });
          }
        } else if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.showQuickReplyPopover = false;
          this.matchedQuickReplies = [];
          this.selectedQuickReplyId = null;
          this.selectedQuickReplyIndex = -1;
        }
      }
    },

    send() {
      var time = new Date();
      if ((store.state.showMsgFlag && store.state.StatusFlag) || localStorage.getItem('chatDebug') === '1') {
        let data = {
          contentType: 0,
          doctorCode: "", //发送者id
          data: "",
          orderNumber: "", //发送时间
          type: 0, //消息内容
        };
        data.data = this.input;
        if (data.data != "") {
          //   /* 自己的信息直接push到数组中 */
          data.orderNumber = store.state.orderNumber;
          let useObj = JSON.parse(JSON.stringify(data));
          data.doctorCode = localStorage.getItem("doctorEmployee");
          useObj.doctorCode = data.doctorCode;
          useObj.sendType = 2;
          useObj.contentData = data.data;
          const isDebug = localStorage.getItem('chatDebug') === '1';
          if (isDebug) {
            // 调试模式：不调接口，直接本地渲染
            if (!data.orderNumber) {
              data.orderNumber = 'DEBUG_' + Date.now();
              useObj.orderNumber = data.orderNumber;
            }
            store.commit("SOCKET_updateChatMessageList", useObj);
            this.scrollChatToBottom();
          } else {
            msgUp(data).then((query) => {
              if (query.code == 0) {
                // store.commit("SET_COUNT", 0);
                store.commit("SOCKET_updateChatMessageList", useObj);
              } else {
                this.tipsFlag = true;
                this.tipsMsg = query.msg;
                setTimeout(() => {
                  this.tipsFlag = false;
                }, 2000);
              }
            });
            this.scrollChatToBottom();
          }
        }
      } else {
        this.tipsFlag = true;
        this.tipsMsg = "请对该患者预约接诊后发送消息";
        setTimeout(() => {
          this.tipsFlag = false;
        }, 2000);
      }

      // }
      /* 清空输入框 */
      this.input = "";
    },
    sendImg(file) {
      const isJPG = file.type === "image/png" || file.type === "image/jpeg";
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG与PNG 格式!");
        return false;
      } else if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 3MB!");
        return false;
      } else {
        let postData = {
          file: "",
        };
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          postData.file = reader.result;
          imgUpload(postData)
            .then((data) => {
              if (data.code == 0) {
                let postImgData = {
                  contentType: 1,
                  data: data.data,
                  doctorCode: localStorage.getItem("doctorEmployee"),
                  orderNumber: store.state.orderNumber,
                  type: 0,
                };
                msgUp(postImgData).then((res) => {
                  if (res.code == 0) {
                    let send_Img = {
                      base64: reader.result,
                      sendDate: new Date(),
                    };
                    store.commit("SET_SENDIMG", send_Img);
                  } else {
                    this.loading2 = false;
                    this.outFlag2 = true;
                    this.errorMsg = res.msg;
                    setTimeout(() => {
                      this.outFlag2 = false;
                    }, 2000);
                  }
                });
              } else {
                this.outFlag2 = true;
                this.errorMsg = "请重新上传图片";
                setTimeout(() => {
                  this.outFlag = false;
                }, 2000);
              }
            })
            .catch(() => {
              this.outFlag2 = true;
              this.errorMsg = "请重新上传图片";
              setTimeout(() => {
                this.outFlag = false;
              }, 2000);
            });
        };
        return false;
      }
    },
    scrollChatToBottom() {
      // 将聊天框定位到底部
      this.$nextTick(() => {
        const chatContainer =
          this.$parent.$parent.$children[0].$refs.boxContent;
        this.$parent.$parent.$children[0].$el.scrollTop =
          this.$parent.$parent.$children[0].$el.scrollHeight;
      });
    },
    sendFlag() {
      if (store.state.StatusFlag == false) {
        this.tipsFlag = true;
        this.tipsMsg = "请在接诊后再尝试开处方";
        setTimeout(() => {
          this.tipsFlag = false;
        }, 2000);
      } else {
        this.CF_Flag = true;
        store.commit("SET_CF_FLAG", this.CF_Flag);
      }
    },
    // 强制打开下拉框
    openQuickReplyDropdown() {
      this.$nextTick(() => {
        if (this.$refs.quickReplySelect) {
          // 模拟点击下拉框来打开它
          const selectElement = this.$refs.quickReplySelect.$el;
          if (selectElement) {
            selectElement.click();
          }
        }
      });
    },

    // 统一方法：关闭主输入框的快捷语Popver并清理状态
    hideQuickReplyPopover() {
      this.showQuickReplyPopover = false;
      this.matchedQuickReplies = [];
      this.selectedQuickReplyId = null;
      this.selectedQuickReplyIndex = -1;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
    },

    // 判断点击是否在某元素内
    isInside(el, target) {
      if (!el || !target) return false;
      try {
        return el === target || el.contains(target);
      } catch (e) {
        return false;
      }
    },

    // 全局点击关闭主输入框的快捷语下拉（更稳健：使用 popperElm + click/mousedown 双监听）
    handleGlobalClick(event) {
      if (!this.showQuickReplyPopover) return;
      const target = event.target;
      const popComp = this.$refs.quickReplyPopover;
      const popEl = popComp && (popComp.popperElm || popComp.$el) ? (popComp.popperElm || popComp.$el) : null;
      const inputEl = this.$refs.mainTextarea && this.$refs.mainTextarea.$el ? this.$refs.mainTextarea.$el : null;

      const inside = this.isInside(popEl, target) || this.isInside(inputEl, target);
      if (!inside) {
        this.hideQuickReplyPopover();
      }
    },


  },
  mounted() {
    this.scrollChatToBottom();
    // 添加快捷键监听，使用capture确保优先级
    document.addEventListener('keydown', this.handleKeydown, true);
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleWindowResize);
    // 初始化textarea高度
    this.$nextTick(() => {
      this.autoResize();
    });

    // 设置popover的参考元素为文本域
    this.$nextTick(() => {
      if (this.$refs.quickReplyPopover && this.$refs.mainTextarea) {
        // 设置参考元素为文本域，这样popover会相对于文本域定位
        this.$refs.quickReplyPopover.referenceElm = this.$refs.mainTextarea.$el;
        console.log('Popover参考元素已设置为文本域');
      }
    });

    // 添加全局点击监听，点击区域外关闭主输入框的快捷语下拉
    document.addEventListener('mousedown', this.handleGlobalClick, true);
    document.addEventListener('click', this.handleGlobalClick, true);
  },

  beforeDestroy() {
    // 移除快捷键监听
    document.removeEventListener('keydown', this.handleKeydown, true);
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleWindowResize);
    // 清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    // 移除全局点击监听
    document.removeEventListener('mousedown', this.handleGlobalClick, true);
    document.removeEventListener('click', this.handleGlobalClick, true);
  },
  watch: {
    ImgData() {
      let postImgData = {
        contentType: 1,
        data: this.storeImgData.cover,
        doctorCode: localStorage.getItem("doctorEmployee"),
        orderNumber: store.state.orderNumber,
        type: 0,
      };
      msgUp(postImgData).then((res) => {
        if (res.code == 0) {
          let send_Img = {
            base64: this.storeImgData.getImg,
            sendDate: new Date(),
          };
          store.commit("SET_SENDIMG", send_Img);
        } else {
          this.loading2 = false;
          this.outFlag2 = true;
          this.errorMsg = res.msg;
          setTimeout(() => {
            this.outFlag2 = false;
          }, 2000);
        }
      });
    },
    // 监听popover显示状态变化
    showQuickReplyPopover(newVal) {
      if (newVal) {
        // Element UI 会自动处理 popover 位置
        console.log('Popover 已显示');
      } else {
        console.log('Popover 已隐藏');
      }
    },
  },
  computed: {
    myInfo() {
      return store.state.myInfo;
    },
    chatType() {
      return store.state.chatType;
    },
    userInfo() {
      return store.state.userInfo;
    },
    ImgData() {
      let ImgData = {
        getImg: store.state.getImg,
        cover: store.state.cover,
      };
      this.storeImgData = ImgData;
      return ImgData;
    },
    stateFlag() {
      return store.state.StatusFlag;
    },

  },
};
</script>

<style scoped>
.inputBox {
  position: relative;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.flexBox {
  display: flex;
  align-items: center;
  padding: 10px 0;
  position: relative; 
  min-height: 40px;
}

.input-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  min-height: 200px;
  padding-right: 190px;
}

.input-row .el-textarea {
  flex: 1;
}

.el-textarea /deep/ .el-textarea__inner {
  border: none !important;
}

.input-row .sendButton {
  position: fixed !important;
  right: 24px !important;
  bottom: 24px !important;
  z-index: 3000;
  height: 40px;
  padding: 0 24px;
  font-size: 15px;
  font-weight: 500;
}

.hoverIcon {
  font-size: 26px;
  color: #0caf60;
}

.hoverIcon:hover {
  color: #0caf60;
  cursor: pointer;
}

.tipsMsgBox /deep/ .el-dialog__header {
  display: none;
  background: rgb(16, 17, 17);
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.tipsMsgBox .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.iconButton {
  margin-right: 20px;
  font-size: 30px;
  cursor: pointer;
  color: #0caf60;
}

.iconButton:hover {
  color: #0caf60;
}

/* 快捷语样式 */
.flexBox { position: relative; }
.quick-reply-container {
  position: absolute; 
  top: 36%;
  transform: translateY(-50%);
  right: 24px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  z-index: 2; 
}


.quick-reply-container /deep/ .el-autocomplete {
  width: 420px;
}

.quick-reply-container /deep/ .el-input__inner {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  height: 38px;
  line-height: 38px;
  padding-left: 12px; 
  border: 1px solid #90e0b6; 
  box-shadow: none; 
  transition: all .2s ease;
}

/* 快捷语标签样式 */
.quick-reply-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  margin-right: 8px;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 60px;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  line-height: 20px;
}

.quick-reply-tag i {
  margin-right: 3px;
  font-size: 10px;
  color: inherit;
}

/* 悬浮状态下的图标样式 */
.quick-reply-item:hover .quick-reply-tag i {
  color: inherit !important;
}

.quick-reply-item.selected .quick-reply-tag i {
  color: inherit !important;
}

.quick-tag {
  background-color: #f0f9ff;
  border: 1px solid #67c23a;
  color: #67c23a;
}

.qa-tag {
  background-color: #fdf6ec;
  border: 1px solid #e6a23c;
  color: #e6a23c;
}

/* 悬浮状态下的标签样式 */
.quick-reply-item:hover .quick-reply-tag {
 
}

.quick-reply-item.selected .quick-reply-tag {
  
}

/* 建议项样式 */
.suggestion-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 0;
}

.suggestion-title {
  text-align: left;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  cursor: pointer;
  flex: 1;
}

.popover-reference {
  position: absolute;
  bottom: -200px;
  left: 0;
  width: 100%;
  height: 1px;
  pointer-events: none;
}

/* 快捷语列表样式 */
.quick-reply-list {
  max-height: 300px;
  overflow-y: auto;
  min-width: 400px;
  /* 显示滚动条 */
  scrollbar-color: #c0c4cc #f5f7fa;
}

/* 自定义滚动条样式 */
.quick-reply-list::-webkit-scrollbar {
  width: 6px;
}

.quick-reply-list::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 3px;
}

.quick-reply-list::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.quick-reply-list::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

.quick-reply-item {
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
  position: relative;
  /* 优化大量数据时的显示 */
  min-height: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 20px;
}

.quick-reply-item:hover {
  background-color: #d7e1ef;
  color: #fff;
  z-index: 10;
}

.quick-reply-item.selected {
  background-color: #d7e1ef;
  color: #fff;
}

.quick-reply-item.selected .item-text {
  color: #333;
}

/* 确保悬浮状态优先级高于选中状态 */
.quick-reply-item:hover {
  background-color: #d7e1ef !important;
  color: #333 !important;
}

.quick-reply-item:hover .item-text {
  color: #333 !important;
}

.quick-reply-item:last-child {
  border-bottom: none;
}

.item-text {
  font-size: 14px;
  color: #303133;
  line-height: 20px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: break-word;
  max-width: 100%;
  cursor: pointer;
  /* 优化大量数据时的文本显示 */
  flex: 1;
}

.quick-reply-item:hover .item-text {
  color: #fff;
}

.quick-reply-container /deep/ .el-input__inner {
  border-radius: 20px;
}

.quick-reply-container /deep/ .el-select:hover .el-input__inner,
.quick-reply-container /deep/ .el-input.is-focus .el-input__inner,
.quick-reply-container /deep/ .el-input__inner:focus {
  border-color: #0caf60 !important;
  box-shadow: 0 6px 14px rgba(12, 175, 96, 0.18);
}

.quick-reply-container /deep/ .el-select-dropdown__item {
  padding: 0 20px;
  line-height: 34px;
}

.quick-reply-container /deep/ .el-select-dropdown__item:hover {
  background-color: #42b6ff;
  color: #fff;
}

.quick-reply-container /deep/ .el-select-dropdown__item.selected {
  color: #42b6ff;
  font-weight: bold;
}

/* 高亮匹配的文本 */
.quick-reply-container /deep/ .el-select-dropdown__item.highlighted {
  background-color: #42b6ff;
  color: #fff;
}

/* 匹配文本高亮 */
.quick-reply-container /deep/ .el-select-dropdown__item .highlight {
  background-color: #ffd700;
  color: #333;
  font-weight: bold;
}

/* 主输入框popover样式 - 使用深度选择器 */
::v-deep .el-popover.main-input-popover {
  padding: 5px;
  font-size: 12px;
  color: #333;
  background-color: #fff;
  z-index: 9999;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: translate3d(0px, 120px, 0px) !important;
}

/* 确保popover在父元素内正确显示 */
.inputBox .main-input-popover {
  position: absolute !important;
}


</style>